import { render, staticRenderFns } from "./CopyToMyAccount.vue?vue&type=template&id=3beb7364&scoped=true"
import script from "./CopyToMyAccount.vue?vue&type=script&lang=js"
export * from "./CopyToMyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb7364",
  null
  
)

export default component.exports